// extracted by mini-css-extract-plugin
module.exports = {"container":"Textarea_container__FEY3n","content":"Textarea_content__1IsCZ","textarea":"Textarea_textarea__1x6PT"};